import { render, staticRenderFns } from "./PowerTeam.vue?vue&type=template&id=41fc42b6&scoped=true&"
import script from "./PowerTeam.vue?vue&type=script&lang=js&"
export * from "./PowerTeam.vue?vue&type=script&lang=js&"
import style0 from "./PowerTeam.vue?vue&type=style&index=0&id=41fc42b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc42b6",
  null
  
)

export default component.exports